export const getPossibleVariationsList = (variations: any) => {
  const list: string[] = [];

  variations.forEach((item: any) => {
    list.push(item.attributes);
  });

  return list;
};
